import type { IGlobalTab } from '@carboncopyco/types/desktop';
import { MemoryRouter, Route, Routes } from 'react-router-dom';
import DemoPlayScreenContent from './DemoPlayScreenContent';

const DemoPlayScreen = ({
  tab,
  withRouter = true,
}: {
  tab: IGlobalTab;
  withRouter?: boolean;
}) =>
  withRouter ? (
    <MemoryRouter>
      <Routes>
        <Route
          path="/*"
          element={<DemoPlayScreenContent tab={tab} />}
        />
      </Routes>
    </MemoryRouter>
  ) : (
    <DemoPlayScreenContent tab={tab} />
  );

export default DemoPlayScreen;
